import React, { useEffect } from 'react';
import Carousel from 'react-material-ui-carousel'
import Image from './img/Engaging-an-AC-Compressor-Clutch.jpg'
import {makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Power from './img/electric.jpg';
import Power1 from './img/power.jpg';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { Parallax } from "react-parallax";
import Para1 from './img/slider/evan.jpg';
import Para2 from './img/slider/evan.jpg';
import Para3 from './img/slider/evan.jpg';
import AOS from 'aos';
import "aos/dist/aos.css";
import { useSharedStyles, colors } from './sharedStyles';

const useStyles = makeStyles((theme) => ({
  ...useSharedStyles(),
  heroSection: {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden',
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `rgba(44, 62, 80, 0)`,
    zIndex: 1,
  },
  heroContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: 'white',
    maxWidth: 800,
    padding: '0 20px',
  },
  heroTitle: {
    fontSize: '3.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.5rem',
    },
  },
  heroSubtitle: {
    fontSize: '1.3rem',
    marginBottom: theme.spacing(4),
    textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
  },
  section: {
    padding: theme.spacing(8, 0),
  },
  lightSection: {
    background: 'linear-gradient(135deg, rgba(248, 251, 255, 0.7) 0%, rgba(232, 244, 253, 0.6) 100%)',
  },
  darkSection: {
    background: 'linear-gradient(135deg, rgba(97, 218, 251, 0.3) 0%, rgba(74, 144, 226, 0.2) 50%, rgba(44, 62, 80, 0.1) 100%)',
    color: 'white',
  },
  card: {
    height: '100%',
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 16px 48px rgba(0,0,0,0.15)',
    },
  },
  cardContent: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: '#2c3e50',
  },
  cardText: {
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#7f8c8d',
  },
  missionCard: {
    background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
    color: 'white',
    borderRadius: 16,
    padding: theme.spacing(4),
    marginBottom: theme.spacing(4),
    boxShadow: '0 8px 32px rgba(97, 218, 251, 0.3)',
  },
  missionTitle: {
    fontSize: '2rem',
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  missionText: {
    fontSize: '1.1rem',
    lineHeight: 1.8,
    marginBottom: theme.spacing(3),
  },
  activitiesCard: {
    background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
    color: '#2C3E50',
    borderRadius: 16,
    padding: theme.spacing(4),
    marginBottom: theme.spacing(4),
    boxShadow: '0 8px 32px rgba(255, 193, 7, 0.3)',
  },
  activitiesTitle: {
    fontSize: '1.8rem',
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  activityItem: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: 'rgba(255,255,255,0.2)',
    borderRadius: 8,
    borderLeft: `4px solid #61DAFB`,
  },
  activityLabel: {
    fontWeight: 600,
    color: '#2C3E50',
    marginBottom: theme.spacing(1),
  },
  prayerCard: {
    background: 'linear-gradient(135deg, #E74C3C 0%, #C0392B 100%)',
    color: 'white',
    borderRadius: 16,
    padding: theme.spacing(4),
    textAlign: 'center',
    boxShadow: '0 8px 32px rgba(220, 53, 69, 0.3)',
  },
  prayerTitle: {
    fontSize: '1.8rem',
    fontWeight: 700,
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '3rem',
    color: '#2c3e50',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '60px',
      height: 4,
      background: 'linear-gradient(45deg, #61DAFB, #FFD700)',
      borderRadius: 2,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },
  caro: {
        backgroundRepeat: 'no-repeat', 
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
    },
  },
  carouselContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: 'white',
  },
  mapContainer: {
    height: 400,
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
  },
}));

function Example(props) {
  const classes = useStyles();
  
  useEffect(() => {
     AOS.init({
      duration: 700
  });
  }, []);
    
  const items = [
        {
      name: "Evangelism",
            image: Para1,
      description: "Spreading the Gospel to all nations"
    },
    {
      name: "Mission Work",
      image: Para2,
      description: "Sharing the love of Christ worldwide"
    },
    {
      name: "Spiritual Growth",
      image: Para3,
      description: "Building faith and transforming lives"
    }
  ];

  const activities = [
    "Evangelist meetings",
    "Vacation Bible School for children",
    "Week of prayer in schools",
    "Free Bibles in local language",
    "Spiritual literature distribution",
    "Addressing basic needs of people"
  ];

    return (
        <div>
      {/* Hero Section with Background Images */}
      <Carousel swipe={true} indicators={false} touch={true} animation={"slide"} interval={5000}>
        {items.map((item, i) => <Item key={i} item={item} />)}
        </Carousel>

      {/* Mission Section */}
      <section className={`${classes.section} ${classes.lightSection}`}>
        <Container maxWidth="lg">
          <Card className={classes.missionCard} data-aos="fade-up">
            <Typography variant="h2" className={classes.missionTitle}>
              The Great Commission
            </Typography>
            <Typography variant="body1" className={classes.missionText}>
              The Great Gospel Commission given to us by Jesus in Matthew 28:18-20, tells us to go ye therefore, 
              and make disciples of All Nations, baptizing them in the name of the Father and of the Son and the Holy Spirit.
            </Typography>
            <Typography variant="body1" className={classes.missionText}>
              Because our mission is to mobilize, motivate and educate people to prepare for Jesus' 2nd coming. 
              We organize short term mission trips to various countries around the world and travel to some remote 
              areas in these countries to spread the Gospel of Jesus.
            </Typography>
          </Card>
        </Container>
      </section>

      {/* Activities Section */}
      <section className={classes.section}>
        <Container maxWidth="lg">
          <Typography variant="h2" className={classes.sectionTitle} data-aos="fade-up">
            Our Evangelism Activities
          </Typography>
          
          <Card className={classes.activitiesCard} data-aos="fade-up">
            <Typography variant="h3" className={classes.activitiesTitle}>
              What We Do
            </Typography>
            <Grid container spacing={2}>
              {activities.map((activity, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <div className={classes.activityItem}>
                    <Typography variant="h6" className={classes.activityLabel}>
                      {activity}
                    </Typography>
                  </div>
                </Grid>
              ))}
            </Grid>
          </Card>
        </Container>
      </section>

      {/* Prayer Section */}
      <section className={`${classes.section} ${classes.lightSection}`}>
        <Container maxWidth="md">
          <Card className={classes.prayerCard} data-aos="fade-up">
            <Typography variant="h3" className={classes.prayerTitle}>
              Let us pray for you
            </Typography>
            <Typography variant="body1" className={classes.missionText}>
              Please pray that God will give us wisdom and strength to keep going forward with our work, 
              in these last days of earth's history to share the Good News that Jesus saves and he is coming again.
            </Typography>
            <Button 
              variant="contained" 
              size="large"
              style={{
                background: 'linear-gradient(45deg, #61DAFB 30%, #FFD700 90%)',
                color: '#2C3E50',
                marginTop: '2rem',
                padding: '12px 32px',
                borderRadius: 8,
                fontWeight: 600,
                fontSize: '1.1rem',
                textTransform: 'none',
                boxShadow: '0 4px 20px rgba(97, 218, 251, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #4A90E2 30%, #FFA500 90%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(97, 218, 251, 0.4)',
                }
              }}
            >
              <a 
                href="mailto:support@3ammissionministry.com" 
                style={{
                  color: '#2C3E50',
                  textDecoration: 'none',
                  fontWeight: 600,
                  fontSize: '1.1rem'
                }}
              >
                Request For Prayer
              </a>
            </Button>
          </Card>
        </Container>
      </section>

      {/* Map Section */}
      <section className={classes.section}>
        <Container maxWidth="lg">
          <Typography variant="h2" className={classes.sectionTitle} data-aos="fade-up">
            Find Us
          </Typography>
          <div className={classes.mapContainer} data-aos="fade-up">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3104.8484336332685!2d-76.81632558464938!3d38.90458117956952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7eab2795cc2e9%3A0x3b7e3088d8779114!2s1011%20Winged%20Foot%20Dr%2C%20Bowie%2C%20MD%2020721%2C%20USA!5e0!3m2!1sen!2sgh!4v1606680803222!5m2!1sen!2sgh" 
              width="100%" 
              height="400" 
              style={{border: 0}} 
              title="location" 
              loading="lazy"
            />
          </div>
</Container>
      </section>
    </div>
  );
}

function Item(props) {
  const classes = useStyles();

     return (
    <div 
      className={classes.heroSection} 
      style={{
        backgroundImage: `linear-gradient(rgba(44, 62, 80, 0.7), rgba(44, 62, 80, 0.7)), url(${props.item.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className={classes.heroOverlay}></div>
      <div className={classes.heroContent}>
        <Typography variant="h1" style={{fontSize: '3.5rem', fontWeight: 700, marginBottom: '1rem'}} data-aos="flip-right">
          {props.item.name}
        </Typography>
        <Typography variant="h5" style={{fontSize: '1.3rem'}} data-aos="zoom-in">
          {props.item.description}
        </Typography>
      </div>
        </div>
  );
}

export default Example;


